module.exports = __webpack_public_path__ + "img/r11.96ef653e.jpg";